// extracted by mini-css-extract-plugin
export default {"CallActive1Content":"CallActive1St_CallActive1Content__bkUOZ","colorActive":"CallActive1St_colorActive__A3W9Q","boxSend":"CallActive1St_boxSend__MogWp"};